<script setup>
</script>

<template>
  <div class="login">
    <form class="login__card" @submit.prevent>
      <h1 class="login__title">Login</h1>

      <label class="ww-field" for="username">
        <span class="ww-field__label">Username</span>
        <input
            type="text"
            class="ww-input"
            id="username"
            name="username"
            placeholder="Username"
            autocomplete="username"
            required
        />
      </label>

      <label class="ww-field" for="password">
        <span class="ww-field__label">Password</span>
        <input
            type="password"
            class="ww-input"
            id="password"
            name="password"
            placeholder="Password"
            autocomplete="current-password"
            required
        />
      </label>

      <label class="login__remember" for="remember">
        <input type="checkbox" class="ww-checkbox" id="remember" name="remember"/>
        Remember me
      </label>

      <button type="submit" class="ww-btn ww-btn--primary">Login</button>
    </form>
  </div>
</template>

<style scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 24px;
  background: var(--ww-navy);
}

.login__card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  max-width: 400px;
  padding: 28px;
  background: var(--ww-surface);
  border-radius: var(--ww-r-2xl);
  box-shadow: var(--ww-shadow-frame);
}

.login__title {
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--ww-text);
}

.login__remember {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 600;
  color: var(--ww-text-body);
  cursor: pointer;
}
</style>
